import {
  pickSummaryColumns,
  summaryCardsGetter,
  amountCardsGetter,
} from './summaryCatalog';

const DETAIL_COLUMN_KEYS = [
  'receiver',
  'amount',
  'monthlyRate',
  'defaultRate',
  'retention',
  'operationDays',
  'dateToPay',
];

export const BASE_CURRENT_CONFIG = {
  includeHeaders: [
    'operationId',
    'dateOperation',
    'lazy_folio',
    'receiver_sortable',
    'amountWithIva',
    'operationDateToPay',
    'operationStatus',
    'offer_pendingDocuments',
    'viewDetail',
  ],
  mobileHeaders: [
    'lazy_folio',
    'receiver_sortable',
    'amountWithIva',
    'operationDateToPay',
    'operationStatus',
    'viewDetail',
  ],
  summaryTableColumns: pickSummaryColumns(DETAIL_COLUMN_KEYS),
  getCards: summaryCardsGetter(['current-invoices', 'accumulated-debt']),
  getAmountCards: amountCardsGetter(['outstanding-capital', 'accumulated-default-interest']),
  showWarnings: true,
};

export const BASE_HISTORIC_CONFIG = {
  includeHeaders: [
    'operationId',
    'dateOperation',
    'lazy_folio',
    'receiver_sortable',
    'amountWithIva',
    'operationDateToPay',
    'collectionDate',
    'operationStatus',
    'viewDetail',
  ],
  mobileHeaders: [
    'lazy_folio',
    'receiver_sortable',
    'amountWithIva',
    'collectionDate',
    'operationStatus',
    'viewDetail',
  ],
  summaryTableColumns: pickSummaryColumns(DETAIL_COLUMN_KEYS),
  getCards: summaryCardsGetter(['historic-invoices', 'available-surplus']),
  getAmountCards: amountCardsGetter(['total-collected']),
  showWarnings: false,
};
